<!-- This component is triggered when the user is creating or editing a receipt. -->
<!-- It displays different sections based on the receipt mode and other conditions. -->
<!-- If the shipment is inbound, the following section will be displayed. -->
<one-receipt *ngIf="!isReceiptLocked"
             [lock]="isReceiptLocked"
             [shippments]="shippments"
             [shipmentsByCurrency]="shipmentsByCurrency"
             [scanners]="scanners"
             (addShipmentRequest)="onAddShippmentRequest($event)"
             (deleteShipment)="onRemoveShipment($event)"
             (discountShipment)="onDiscountShipment($event)"  
             (duplicateShipment)="onDuplicateShipment($event)"
             (close)="onClose()">
</one-receipt>
<app-commercial-invoice
                        *ngIf="showCommercialInvoice"
                        (close)="onCloseCommercialInvoice()"
                        (onAddShipmentAttachment)="addShipmentAttachment($event)"
                        shipmentAttachment=""
                        [scanners]="scanners"></app-commercial-invoice>
<generate-commercial-invoice
                        *ngIf="showGenerateCommercialInvoice"
                        (close)="onCloseGenerateCommercialInvoice()"
                        (onGenerateInvoiceClick)="onGenerateInvoiceClick($event)"
                        [generateInvoiceData]="generateInvoiceData"
                        [receiptData]="this.receipt"></generate-commercial-invoice>
<div class="row">
  <div class="col-md-12 header">
    <h4><b>{{ 'pages.createReceiptPage.createReceipt' | translate }}</b></h4>
    <!--<button class="btn btn-primary" (click)="paymentIntegration()">Payment Integration</button>-->
    <p></p>
    <button class="btn btn-primary pull-right" (click)="showShippments()"><i class="armx-icon armx-th"></i> {{ 'pages.createReceiptPage.showShipments' | translate }}</button>
  </div>
</div>

<ul class="container section-list ">
  <li class="row">
    <receipts-mode #receiptModeEle
                   (modeObject)="onModeSelected($event)"
                   [enableChange]="enableChangeMode()"
                   [changing]="change"
                   [initialValue]="initalShipment"
                   (isEnableSelectProductGroup)="enableSelectProductGroup($event)"
                   (isEnableSelectInboundAWB)="enableSelectInboundAWB($event)"
                   (isEnableSelectCategory)="enableSelectCategory($event)">
                   (isEnableSelectPackaging)="enableSelectPackaging($event)">
    </receipts-mode>

  </li>
  <!--openclose based on the reciept mood and if it's not null-->
  <li *ngIf="showInboundAWB" class="row" [@openClose]="receipt.mode !=null && receipt.mode == 'Inbound' ? 'open' : 'closed'">
    <!-- This section is displayed when the receipt mode is 'Inbound'. -->
    <inbound-awb (inboundShipments)="onSelectInboundAWB($event)" [changing]="change"></inbound-awb>
  </li>
  <li *ngIf="showDropOffAWB" class="row" [@openClose]="receipt.mode !=null && receipt.mode == 'DropOff' ? 'open' : 'closed'">
    <dropoff-awb (dropoffShipments)="onSelectDropOffAWB($event)" (addToReceipt)="addToReceipt()" (onRTIShipment)="handleRTIShipment($event)"  [changing]="change"></dropoff-awb>
  </li>

    <!-- This section is displayed when the receipt mode is 'Packaging'. -->
    <li *ngIf="showPackaging" class="row" [@openClose]="receipt.mode !=null && receipt.mode == 'Packaging' ? 'open' : 'closed'">
    <packaging-awb (selectedSize)="onSelectPackagingAWB($event)" (PackagingPrice)="handleSelectedPackaging($event)" [changing]="change" ></packaging-awb>
</li>
  <li *ngIf="showCategory" class="row" [@openClose]="receipt.mode !=null && receipt.mode == 'Misc' ? 'open' : 'closed'">
    <misc-category [receiptSubTypes]="receiptSubTypes"
                   [changing]="change"
                   (categoryObject)="onSelectCategotyObject($event)"
                   (isEnableSelectMiscAWBDetails)="enableSelectMiscAWBDetails($event)">
    </misc-category>
  </li>
  <li *ngIf="MiscAWBDetails" class="row" [@openClose]="receipt.category !=null && receipt.mode == 'Misc' ? 'open' : 'closed'">
    <misc-awb-details (detailsObject)="onSelectDetailsObject($event)"
                      [changing]="change"
                      [isRequiredShipmentNumber]="isRequiredShipmentNumberMisc"
                      [isRequiredComments]="isRequiredCommentsMisc"
                      [receiptSubTypeId]="receiptSubTypeIdMisc">
    </misc-awb-details>
  </li>
  <li *ngIf="showProductGroup" class="row" [@openClose]="receipt.mode !=null && receipt.mode == 'Outbound' ? 'open' : 'closed'">
    <receipts-product-group 
                            #receiptProductGroupEle
                            (productGroupObject)="onProductGroupSelected($event)"
                            [enableChange]="enableChangeForProductGroup()"
                            [changing]="change"
                            (isEnableSelectProductType)="enableSelectProductType($event)"
                            (isEnableSelectCountry)="enableSelectCountry($event)">
    </receipts-product-group>

  </li>
  <span class="invalid" *ngIf="invalidResolve">{{invalidCountryMsg}}</span>
  <!--<li *ngIf="showCountry" class="row" [@openClose]="receipt.productGroup !=null && receipt.productGroup == 'EXP' ? 'open' : 'closed'">-->
  <li *ngIf="showCountry && !invalidResolve" class="row" [@openClose]="receipt.productGroup !=null ? 'open' : 'closed'">
    <drop-down-List [label]="'Country'"
                    [selectedEl]="receipt.country"
                    [changing]="change"
                    [ddlContent]="countries"
                    [enableChange]="enableChangeForCountry()"
                    (dllObject)="onCountrySelect($event)"
                    (isEnableSelectPostalCode)="enableSelectPostalCode($event)">
    </drop-down-List>
  </li>

  <li *ngIf="showPostalCode" class="row" [@openClose]="receipt.country !=null && postCodeRequired ? 'open' : 'closed'">
    <postal-code-resolver #postalCode
                          [enableChange]="enableChange('city')"
                          [changing]="change"
                          (postalCodeSelect)="onPostalCodeSelect($event)"
                          [countryCode]="countryCode"
                          [postelCodeText]="receipt.postalCode"
                          (isEnableSelectStates)="enableSelectStates($event)">
    </postal-code-resolver>
  </li>
  <li *ngIf="showCity" class="row" [@openClose]="showTheCity() ? 'open' : 'closed'">
    <drop-down-List [label]="'City'"
                    [selectedEl]="receipt.city"
                    [changing]="change"
                    [ddlContent]="cities"
                    (dllObject)="onCitySelect($event)"
                    [enableChange]="enableChangeCity()"
                    (isEnableSelectProductType)="enableSelectCity($event)"
                    (isEnableSelectCity)="onCityChange()"></drop-down-List>

  </li>
  <span class="invalid" *ngIf="invalidCity">{{invalidCityMessage}}</span>
  <li *ngIf="showTheState == true && !invalidCity" class="row" [@openClose]="showState() ? 'open' : 'closed'">
    <drop-down-List [label]="'States'"
                    [selectedEl]="receipt.state"
                    [ddlContent]="states"
                    [changing]="change"
                    [enableChange]="enableChange('productType')"
                    (dllObject)="onStateSelect($event)"
                    (isEnableSelectCity)="enableSelectProductType($event)">
    </drop-down-List>

  </li>
  <li *ngIf="showProductTypeFun() && !invalidCity" class="row" [@openClose]="showProdutType() && !invalidCity ? 'open' : 'closed'">
    <receipts-product-type #productTypeEle
                          (productTypeObject)="onProductTypeSelect($event)"
                          [enableChange]="enableChange('shipper')"
                          [changing]="change"
                          [productTypes]="productTypes"
                          (isEnableSelectShipper)="enableSelectShipper($event)"></receipts-product-type>
  </li>
  <li *ngIf="showShipper" class="row" [@openClose]="enableShipper() ? 'open' : 'closed'">
    <receipts-shipper #shipperReceipt
                      (shipperInfoObject)="onShipperSelect($event)"
                      [enableChange]="enableChange('consigneeDetails')"
                      [changing]="change"
                      [userAccounts]="userAccounts"
                      [shipperTypes]="shipperTypes"
                      [shipperNationalities]="shipperNationalities"
                      [countryCode]="branchCountryCode"
                      (isEnableSelectConsigneeDetails)="enableSelectConsigneeDetails($event)"></receipts-shipper>
  </li>
  <li *ngIf="showConsigneeDetails && receipt.shipper !=null" class="row">
    <receipts-consignee-details (consigneeDetailsObject)="onConsigneeDetails($event)"
                                [countryCode]="countryCode"
                                [changing]="change"
                                [enableChange]="enableChange('services')"
                                [productType]="receipt.productType.Code"
                                [pickUpBranches]="pickUpBranches"
                                (isEnableSelectServices)="enableSelectServices($event)"
                                [countryType]="selectedCountryType">

    </receipts-consignee-details>
  </li>
  <li *ngIf="showServices" class="row" [@openClose]="receipt.consigneeDetails !=null ? 'open' : 'closed'">
    <receipts-services [services]="services"
                       [changing]="change"
                       [enableChange]="enableChange('commodity')"
                       [currenceis]="currenceis"
                       (servicesObject)="onSelectServices($event)"
                       (isEnableSelectCommodity)="enableSelectCommodity($event)"></receipts-services>
  </li>
  <li *ngIf="showCommodity" class="row" [@openClose]="receipt.services !=null ? 'open' : 'closed'">
    <receipt-commodity [label]="'Commodity Description'"
                       [enableChange]="commedityEnableChange"
                       [changing]="change"
                       [ddlContent]="commodities"
                       [currenceis]="currenceis"
                       [isDutiable]="receipt?.productType?.IsDutiable"
                       [branchCurrencyCode]="branchCurrencyCode"
                       (comedityObject)="onSelectCommodity($event)"
                       (isEnableSelectShipmentItems)="enableSelectShipmentItems($event)">
    </receipt-commodity>
  </li>
  <li *ngIf="showShipmentItems" class="row" [@openClose]="receipt.commodity !=null ? 'open' : 'closed'">
    <receipts-shippment-items [prodctgroup]="receipt.productGroup"
                              [changing]="change"
                              (shipmentItemObject)="onShipmentItemAdded($event)"
                              [enableChange]="additionalChargesEditRequest"
                              (changeRequest)="onShipmentItemsChangeRequest($event)">
    </receipts-shippment-items>
  </li>
  <li class="row" [@openClose]="isReceiptAdditionalChargesNeeded || receipt.additionlCharges != null ? 'open' : 'closed'">
    <receipt-additional-charges (additionalChargesObj)="onSelectAddtionalCharges($event)"
                                [changing]="change"
                                (editRequest)="onEditRequest($event)"
                                (cancelAdditionalCharges)="onCancelAdditionalCharges($event)"
                                [resetAdditionalCharges]="resetAdditionalCharges"></receipt-additional-charges>
  </li>


  
</ul>

<div id="theEnd">
  <div style="margin-left: 50px;"
       class="row footer-button"
       *ngIf="addToReceiptHandler()">
    <p></p>
    <div class="armx-btn-group">
      <button class="btn btn-primary"
              *ngIf="addToReceiptHandler() && isReceiptAdditionalChargesNeeded == false && receipt.mode == 'Outbound'"
              (click)="isReceiptAdditionalChargesNeeded = true;">
        {{ (this.receipt.additionlCharges == null?'pages.createReceiptPage.addAdditionalCharges': 'pages.createReceiptPage.editAdditionalCharges') | translate}}
      </button>
      <button class="btn btn-default"
              style="margin-left: 15px;"
              *ngIf="receipt.mode=='Outbound'"
              (click)="showCommercialInvoice = true"
              [disabled]="tempDisable">
        {{ 'pages.createReceiptPage.attachCommercialInvoice' | translate }}
      </button>
      <button class="btn btn-default"
              style="margin-left: 15px;"
              *ngIf="receipt.mode=='Outbound'"
              (click)="showGenerateCommercialInvoice = true"
              [disabled]="tempDisable">
        {{ 'pages.createReceiptPage.generateCommercialInvoice' | translate }}
      </button>
      <button class="btn btn-info"
              *ngIf="isReceiptAdditionalChargesNeeded==false"
              (click)="addToReceipt()"
              [disabled]="tempDisable">
        {{ 'common.addReceipt' | translate }}
      </button>
  </div>
    <span [innerHtml]="addToReceiptValidationMessage"></span>
  </div>

</div>












